import React from "react";
import Helmet from "react-helmet";
import { Link } from "@reach/router";

import Navigation from "../../components/WaveNavigation";
import Maps from "../../components/Maps";

const getLots = function (lots, type) {
  return lots.map((lot) => {
    if (lot.type == type) {
      return (
        <li key={lot.id}>
          <span className="lot-number">{lot.id}</span> {lot.title}{" "}
          <span className="lot-address">({lot.address})</span>
        </li>
      );
    }
  });
};

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Parking Information"
      meta={[
        {
          name: "description",
          content: "Fire Island Ferries parking information.",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container page">
      <div className="heading">
        <h2>Info</h2>
        <h1>Parking</h1>
      </div>
      {/* <p>
        Season parking is available Tuesday, December 3rd, 2024 for misc.
        applications.{' '}
        <a href="https://seasonparking.fireislandferries.com">Click Here</a> for
        more information and to apply.
      </p> */}
      <p>
        Parking fills up fast during the summer season. Be sure to leave enough
        time to find parking prior to your trip time. Below is a list of parking
        lots in and around the <strong>Fire Island Ferries</strong> terminals.
        The map at the bottom of the page shows the location of our terminals
        and auxilary parking.
      </p>
      <div className="alert alert-info">
        <h4 className="alert-heading">Avoid Parking Delays</h4>
        <p>
          We recommend using public transportation or <strong>Uber</strong> to
          get to the ferry terminals.
        </p>
        <p>
          Ferry tickets are available for purchase in the Uber app to help
          streamline your travels.
        </p>
        <p className="mb-0">
          Shuttles are available (for a fee through David's Taxi) from the Bay
          Shore train station.
        </p>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h3>Terminals</h3>
          <p>
            Parking located at the terminals are available on a first come
            basis. Parking does fill quickly during the summer season. Be sure
            to leave enough time to allow for the additional time required to
            find alternative lots.
          </p>
          <h4>Rates (All rates are per calendar day)</h4>
          <div className="text-center price-chart mb-4 mt-4">
            <h5>Daily</h5>
            <div className="row">
              <div className="col-md-6">
                <span className="amount">$15</span>
                <span className="type">Weekday</span>
                <span className="days">(Mon-Thur)</span>
              </div>
              <div className="col-md-6">
                <span className="amount">$25</span>
                <span className="type">Weekend</span>
                <span className="days">(Fri-Sun & Holidays)</span>
              </div>
            </div>
            <h5>Specials</h5>
            <div className="row">
              <div className="col-md-4">
                <span className="amount">$75</span>
                <span className="type">Full Weekend</span>
                <span className="days">(Fri, Sat & Sun)</span>
              </div>
              <div className="col-md-4">
                <span className="amount">$125</span>
                <span className="type">Full Week</span>
                <span className="days">(7 Consecutive Days)</span>
              </div>
              <div className="col-md-4">
                <span className="amount">$495</span>
                <span className="type">Monthly</span>
                <span className="days">(30 Consecutive Days)</span>
              </div>
            </div>
          </div>
          <h4>Terminal Lots</h4>
          <ul className="lot-list">{getLots(markers, "Terminal")}</ul>
        </div>
        <div className="col-md-6">
          <h3>Auxilary Parking</h3>
          <p>
            Auxilary parking lots are managed by outside entities including the
            Town of Islip and private owners. Pricing varies by location. Please
            be advised that the information provided below may change at anytime
            without notice to us or this page.
          </p>
          <h4>Rates</h4>
          <p>
            For auxilary parking lots, rates vary depending on the lot. Most
            municipal lots are pay per hour.
          </p>
          <h4>Auxilary Lots</h4>
          <ul className="lot-list">{getLots(markers, "Auxilary")}</ul>
        </div>
      </div>
    </div>
    <Maps lat="40.718967" lng="-73.245097" zoom="14" markers={markers} />
  </div>
);

const markers = [
  {
    title: "Main Terminal",
    id: 1,
    type: "Terminal",
    lat: "40.717738",
    lng: "-73.240394",
    address: "Gate 1, 99 Maple Ave.",
  },
  {
    title: "West Terminal",
    id: 2,
    type: "Terminal",
    lat: "40.716218",
    lng: "-73.242529",
    address: "Gate 2, 104 Maple Ave.",
  },
  {
    title: "Saltaire Terminal",
    id: 3,
    type: "Terminal",
    lat: "40.715738",
    lng: "-73.240203",
    address: "Gate 3",
  },
  {
    title: "Maple Ave. Marina",
    id: 4,
    type: "Auxilary",
    lat: "40.716298",
    lng: "-73.241360",
    address: "121 Maple Ave.",
  },
  {
    title: "Maple Ave. Dock Municipal Lot",
    id: 5,
    type: "Auxilary",
    lat: "40.714295",
    lng: "-73.239884",
    address: "End of Maple Ave.",
  },
  {
    title: "Gibson Municipal Lot",
    id: 6,
    type: "Auxilary",
    lat: "40.719198",
    lng: "-73.249197",
    address: "Field 13, Gibson Street",
  },
  {
    title: "Gibson Municipal Lot",
    id: 7,
    type: "Auxilary",
    lat: "40.720548",
    lng: "-73.247507",
    address: "Field 14, Gibson Street",
  },
  // {
  //   title: "Gibson Municipal Lot",
  //   id: 8,
  //   type: "Auxilary",
  //   lat: "40.721372",
  //   lng: "-73.245924",
  //   address: "Field 15, Gibson Street",
  // },
  {
    title: "Mechanicsville Municipal Lot",
    id: 8,
    type: "Auxilary",
    lat: "40.720876",
    lng: "-73.250271",
    address: "Field 7, Mechanicsville Rd.",
  },
  {
    title: "Bay Shore Train Station",
    id: 9,
    type: "Auxilary",
    lat: "40.724885",
    lng: "-73.252761",
    address: "4th Ave.",
  },
  // {
  //   title: 'Touro College Ferry Parking',
  //   id: 10,
  //   type: 'Auxilary',
  //   lat: '40.723302',
  //   lng: '-73.249578',
  //   address: '4th Ave.',
  // },
];
